import { useQuery } from "@tanstack/react-query";
import { getAllContents, getAllModules, getContentById, getContentsByModule, searchGuidesAndTroubleshooting } from "../../api/professoru/contents.api";
import { showToast } from "../../helper/ShowToast";

export const useModules = () => {
    return useQuery({
        queryKey: ['modules', ''],
        queryFn: () => getAllModules(),
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to fetch modules"
            ),
    });
}

export const useContents = (params = {}, options = {}) => {
    return useQuery({
        queryKey: ['contents', params],
        queryFn: () => getAllContents(params),
        ...options,
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to fetch contents"
            ),
    });
}

export const useContentById = (id) => {
    return useQuery({
        queryKey: ['content', id],
        queryFn: () => getContentById(id),
        enabled: !!id,
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to fetch content"
            ),
    });
}

export const useContentByModule = (id, options = {}) => {
    return useQuery({
        queryKey: ['content', id],
        queryFn: () => getContentsByModule(id),
        enabled: !!id,
        ...options,
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to fetch contents"
            ),
    });
}

export const useGuideSearch = (params = {}, options = {}) => {
    return useQuery({
        queryKey: ['guide-search', params],
        queryFn: () => searchGuidesAndTroubleshooting(params),
        ...options,
        onError: (err) =>
            showToast(
                "error",
                err?.response?.data?.message || "Failed to search guides"
            ),
    });
}